import { render, staticRenderFns } from "./VehicleAddedModal.vue?vue&type=template&id=2bfc3598"
import script from "./VehicleAddedModal.vue?vue&type=script&lang=js"
export * from "./VehicleAddedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports